<template>
  <div>
    <vs-table :data="history" class="text-nowrap">
      <template slot="thead">
        <vs-th>Data</vs-th>
        <vs-th>Typ</vs-th>
        <vs-th>Liczba punktów</vs-th>
        <vs-th>Saldo po zmianie</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr class="border-top" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="d-flex no-block align-items-center">
              <div class>
                <h5 class="mb-0 font-16 font-medium">{{ data[indextr].date }}</h5>
              </div>
            </div>
          </vs-td>
          <vs-td>{{ data[indextr].description }}</vs-td>
          <vs-td style="font-weight:700">{{ data[indextr].value }}</vs-td>
          <vs-td>
            <span class="font-medium">{{ data[indextr].saldo }}</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
export default {
  name: "MonthTable",
  props: {
    history: {
      required: true
    }
  },
  data: () => ({
    title: "MonthTable",

    // Data for data[indextr]
    monthtable: [
      {
        date: "03.04.2020",
        date_time: "10:34",
        projectname: "Dodanie punktów",
        statustext: "Zablokowane",
        statuscolor: "warning",
        status: "text-warning",
        week: "+17",
        money: "0"
      },
      {
        date: "04.04.2020",
        date_time: "11:14",
        projectname: "Odblokowanie punktów",
        statustext: "Dostępne",
        statuscolor: "success",
        status: "text-success",
        week: "0",
        money: "17"
      },
      {
        date: "12.04.2020",
        date_time: "00:34",
        projectname: "Odjęcie punktów",
        statustext: "Odjęcie",
        statuscolor: "danger",
        status: "text-danger",
        week: "-10",
        money: "7"
      },
      {
        date: "13.04.2020",
        date_time: "14:56",
        projectname: "Dodanie punktów",
        statustext: "Zablokowane",
        statuscolor: "warning",
        status: "text-warning",
        week: "+150",
        money: "7"
      },
      {
        date: "21.04.2020",
        date_time: "13:10",
        projectname: "Odblokowanie punktów",
        statustext: "Dostępne",
        statuscolor: "success",
        status: "text-success",
        week: "0",
        money: "157"
      },
    ]
  })
};
</script>